import React, { useRef, useEffect } from "react";

/**
 * ClickAwayListener - Detects clicks outside of a component
 * @param {object} props Component props
 * @param {function} props.onClickAway Function to call when click is detected outside
 * @param {React.ReactNode} props.children Child elements
 * @author Forge
 * @date 2026-04-02
 * @version 1.0
 */
export default function ClickAwayListener({ onClickAway, children }) {
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        onClickAway();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [onClickAway]);

  return <div ref={containerRef}>{children}</div>;
}
